import React, { useState } from 'react';
import ExportAll from "./ExportAll";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import { SSelect } from '@avalara/skylab-sdk/react';

const ExportAllByFileType = ({
    options,
    onSelect,
    onExport,
    showToast,
    toasterStatus,
    toasterTitle,
    toasterDetails,
    onClose,
    label,
    exportFor, 
    elementType,
    isExportEnabled 
}) => {
    if (!isExportEnabled) return <></>;
    
    const optionsMap = new Map(options.map(option => [option.value, option])); // Create a Map for faster lookups
    const [selectedValue, setSelectedValue] = useState('-1');
    
    return (
        <div data-testid="export-file-type-container" className="float-left mr10 mt10" style={{ display: 'flex' }}>
            <fieldset>
                <label htmlFor="file-type-selector">
                    <LanguageStringResolver string='export_by_file_type_option_label'/>
                </label>
                <SSelect
                    inputId="file-type-selector"
                    data-testid="file-type-selector"
                    optionsList={[
                        { label: 'Select format', value: '-1', selected: selectedValue === '-1' },
                        ...options.map(o => ({ ...o, selected: selectedValue === o.value }))
                    ]}
                    onS-select={(event) => {
                        const selected = event?.detail?.item;
                        const value = selected?.value ?? '-1';
                        setSelectedValue(value);
                        const selectedOption = optionsMap.get(value);
                        onSelect(selectedOption || { label: 'Select format', value: '-1' })
                    }}
                />
            </fieldset>
            <div className="ml10 mt22">
                <ExportAll
                    testId={"file-type-export-btn"}
                    exportLabel= {label}
                    exportClick={onExport}
                    exportFor= {exportFor}
                    showToast={showToast}
                    elementType={elementType}
                    toastType={toasterStatus}
                    toastTitle={toasterTitle}
                    toastDetails={toasterDetails}
                    onCloseClick={onClose}
                />
            </div>
        </div>
    );
};

export default ExportAllByFileType;

